import { render, staticRenderFns } from "./FundList.vue?vue&type=template&id=add10f36&scoped=true"
import script from "./FundList.vue?vue&type=script&lang=js"
export * from "./FundList.vue?vue&type=script&lang=js"
import style0 from "./FundList.vue?vue&type=style&index=0&id=add10f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add10f36",
  null
  
)

export default component.exports